import React, { useState, useEffect, memo } from 'react';
import { withRouter } from '~HOC';
import { connect } from 'react-redux';
import { Slider, Input } from '../../../component';
import Circle from '../../../component/common/skeleton/Circle';
import Text from '../../../component/common/skeleton/Text';
import Squre from '../../../component/common/skeleton/Squre';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flightBookingRoutes } from '../../../utils/consts';
import { updateRoute } from '../../../utils/utility/booking';
import { convertDate } from '../../../utils/utility';
// importing svg-components
import { SearchIcon, EditIcon } from '~svg/index';
import './previousPassenger.scss';

const PreviousPassenger = (props) => {
  const {
    phrase,
    searchPhrase,
    passengerList,
    user,
    totalRecords,
    isFlightInvoice = false,
    language,
    editUser,
    parsedQueryStr,
    loadMorePassenger,
    onClick,
    onEditUser,
    selectedPassenger,
    isLoading,
  } = props;

  const [userDetail, setUserDetail] = useState(
    isFlightInvoice
      ? passengerList?.[0]
      : selectedPassenger
      ? selectedPassenger
      : null,
  );
  const [passengerPhrase, setPassengerPhrase] = useState(phrase);

  const route = updateRoute(
    'target',
    flightBookingRoutes.selectFlight,
    '/#/login',
    parsedQueryStr,
  );
  useEffect(() => {
    const delayFn = setTimeout(() => {
      if (phrase !== passengerPhrase) {
        searchPhrase(passengerPhrase);
      }
    }, 1000);
    return () => clearTimeout(delayFn);
  }, [passengerPhrase]);

  useEffect(() => {
    onClick(userDetail);
  }, [userDetail]);

  useEffect(() => {
    setUserDetail(
      isFlightInvoice
        ? passengerList[0]
        : selectedPassenger
        ? selectedPassenger
        : {},
    );
  }, [passengerList]);

  return isLoading && user ? (
    <div className="w-100 d-flex flex-column justify-content-around    default-border-radius bg-primary-light previouspassenger-container-skeleton">
      <div className="mx-title mt-2">
        <Squre width="200px" height="21px" />
      </div>
      <div className="w-100 d-flex justify-content-around align-items-center overflow-hidden items-list">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => {
          return (
            <div key={item}>
              <Circle width="32px" height="32px" />
              <Text className="mt-2" />
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    <div
      className="previousPassenger-container d-flex p-3 p-sm-4 flex-column w-100 position-relative 
          default-border-radius bg-primary-light"
      style={{
        backgroundColor: '#4753B5',
        zIndex: '1',
        transition: 'all 1s',
        overflow: 'hidden',
      }}
    >
      {editUser && (
        <div
          className="d-flex d-md-none text-white flex-fill flex-column justify-content-center font-msmall font-sm-small"
          style={{
            background: '#4B56C0',
            borderTopLeftRadius: '2rem',
            borderTopRightRadius: '2rem',
          }}
        >
          <div className="text-start  ">
            <FormattedMessage id="booking.editissuer" />
          </div>
          <div className="flex-fill d-flex w-100 py-2 align-items-center ">
            <div className="d-flex align-items-center w-100 font-smaller  font-sm-msmall  ">
              <div className="d-flex align-items-center justify-content-between w-100">
                <div className="d-flex">{editUser?.firstName}</div>
                <div className="d-flex">{editUser?.lastName}</div>
                <div className="d-flex text-break">{editUser?.email}</div>
                <div className="d-flex">{editUser?.address}</div>
              </div>
              <span
                className={`cursor-pointer ${
                  language.direction === 'rtl' ? 'pr-3' : 'pl-3'
                } `}
                onClick={onEditUser}
              >
                <EditIcon size={12} color="#fff" />
              </span>
            </div>
          </div>
        </div>
      )}

      <div
        className="top-container d-flex w-100 position-relative  "
        style={{
          borderTopRightRadius: '2rem',
          borderTopLeftRadius: '2rem',
          zIndex: '2',
        }}
      >
        <div className="d-flex pb-2 pb-md-3 text-light cursor-pointer passportStyle justify-content-start align-items-center w-50">
          {/* input search */}

          {props.location.pathname === '/booking/identify' && user?.length ? (
            <Input
              autoComplete="off"
              name="serachInput"
              onChange={(e) => setPassengerPhrase(e.target.value)}
              label={
                passengerPhrase === ''
                  ? props.intl.formatMessage({
                      id: `booking.${
                        window.innerWidth >= 326
                          ? 'searchmypassenger'
                          : 'search'
                      }`,
                    })
                  : ''
              }
              value={passengerPhrase}
              py="p-0"
              type="text"
              margin="m-0"
              inputClassName="p-0 mx-lg-1 mx-0 bg-transparent border-0  prevPassForSearchInputStyle px-2 "
              tabIndex="1"
              labelPosition=""
              bottomClass="m-0"
              topClass="p-0"
              themeMode="light"
              outSideLabel={true}
              outSideLabelClass={`position-absolute font-msmall font-sm-small  font-lg-small text-third font-weight-lighter bg-transparent prevPassForLableOfSearchInputStyle
                    mx-4`}
              outSideLabelPosition="side"
              iconUrl={<SearchIcon size={16} color="#85cd95" />}
              boxColor="#4b56c0 border-0 "
            />
          ) : props.location.pathname === '/booking/flight-invoice' ? (
            <span className="text-right text-white font-msmall font-sm-small">
              <FormattedMessage id="booking.passengerinfo" />
            </span>
          ) : null}
        </div>
      </div>
      {/* ----------------------------------------------------------------------------------------------------------- */}

      {!user && !isFlightInvoice ? (
        <div className="d-flex flex-wrap  w-100 text-white mb-3 p-md-3 d-flex w-100 justify-content-center font-lg-large font-msmall font-sm-small">
          <span className="d-flex text-start">
            <FormattedMessage id="booking.toViewTheListOfPreviousPassengers" />
          </span>
          <a href={route} className="text-secondary-light px-1 pointer">
            <FormattedMessage id="user.login" />
          </a>
          <span className="px-1">
            <FormattedMessage id="booking.pleaselogin" />
          </span>
        </div>
      ) : (
        <></>
      )}
      {/* --------------------------------------------------------------------- */}
      {user && !passengerList.length ? (
        <div className=" text-white p-3 d-flex w-100 justify-content-center ">
          <span className="blockquote cursor-pointer font-large font-sm-large font-md-xlarge">
            <FormattedMessage id="profile.notfound" />
          </span>
        </div>
      ) : null}
      {/* ---------------------------------------------------Slider-------------------------------------------------------- */}
      {passengerList.length && (user || isFlightInvoice) ? (
        <div
          className={`d-flex user-container ${
            passengerList.length > 8 ? 'slider-container' : ''
          } ${language.direction} d-flex py-0 text-light position-relative`}
          style={{
            zIndex: '2',
          }}
        >
          <Slider
            isFlightInvoice={isFlightInvoice}
            direction={language.direction}
            passengerList={passengerList}
            totalRecords={totalRecords}
            handleOnClick={(item) => setUserDetail(item)}
            loadMorePassenger={() => {
              loadMorePassenger();
            }}
          />
        </div>
      ) : null}
      {/* ------------------------------------------------------------------------------------------------------------ */}
      <div
        className={`${
          isFlightInvoice || (userDetail && Object.entries(userDetail)?.length)
            ? 'd-flex'
            : 'd-none'
        }  w-100`}
        style={{
          transition: 'all 1s',
        }}
      >
        {passengerList.length && (user || isFlightInvoice) ? (
          <div
            className={`detailcontainer font-lg-small default-border-bottom-radius-xsmall 
                 ${
                   passengerList.length > 8
                     ? ''
                     : `default-border-${
                         language.direction == 'rtl' ? 'left' : 'right'
                       }-radius-xsmall`
                 } 
                font-smaller font-sm-msmall py-2 text-light d-flex flex-row flex-fill col p-0  justify-content-around align-self-center align-items-center`}
            style={{
              backgroundColor: 'rgb(44, 53, 202, 0.5)',
              zIndex: '1',
              bottom: 0,
              transition: 'all 1s',
              maxHeight: '45px',
            }}
          >
            <div>{userDetail?.type}</div>
            <div>{userDetail?.firstName}</div>
            <div>{userDetail?.lastName}</div>

            <div>
              {language.direction === 'ltr'
                ? userDetail?.birthDate
                : convertDate(userDetail?.birthDate, 'en', 'fa')}
            </div>
            <div>
              {language.direction === 'ltr'
                ? userDetail?.passportExpireDate
                : convertDate(userDetail?.passportExpireDate, 'en', 'fa')}
            </div>
            <div>{userDetail?.nationalCode}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    language: state?.language,
    user: state?.user?.userInfo?.user,
  };
}

export default connect(
  mapStateToProps,
  {},
)(withRouter(injectIntl(memo(PreviousPassenger))));
